var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pkg.version.readme)?_c('vue-markdown',{staticClass:"beast-markdown",domProps:{"textContent":_vm._s(_vm.pkg.version.readme)}}):_c('div',[_vm._v("\n  "+_vm._s(_vm.pkg.description)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }